import Concrete from './concrete';
import _rotate from './rotate';
import _background from './background'

export default (container, startAnimation, v, cb, hover) => {
    const viewport = new Concrete.Viewport({
        container,
        width: 400,
        height: 500
    });

    return _rotate(viewport, startAnimation, v, cb, hover)
};
